export default __webpack_public_path__ + "static/media/regulatory--low-speed-vehicle-permitted--g1.30c92b2d.png";